import React from 'react'
import { Register } from '../../styles.style'
import Main from '../steps/main.component'

const Content = ({
	toastError,
	toastSuccess,
	hideLoading,
	showLoading,
	user
}) => {
	return (
		<Register>
			<Main
				toastSuccess={toastSuccess}
				toastError={toastError}
				hideLoading={hideLoading}
				showLoading={showLoading}
				user={user}
			/>
		</Register>
	)
}

export default Content
